export default __webpack_public_path__ + "static/media/img-0206-columbia-premium-face.0b61b554.png";